// Utilities
import {
  gcAccessToken,
  gcEnvironment,
  fetchWrap,
} from "../../components/common/utilities/fetchWrap";
import config from "../../config";
import { AuthenticationConstants } from '../../components/common/utilities/appConstants'
import { getSessionStorageItem } from '../../components/common/utilities/applicationStorage'
/**
 * @async
 * @description Get's the current integration types from genesys cloud api.
 * @return {Promise<object>} { data, count, correlationIds, httpResults }
 */
export const fetchIntegrations = async () => {
  const urlbase = config.endpoints.endpoint;
  const url = `${urlbase}/fetchIntegrations`;
  const token = gcAccessToken();
  const gcEnv = gcEnvironment();

  return await fetchWrap(
    {url,
    options: {
      method: "GET",
    },
    token,
    auth: true,
    cookies: false,
    headerOptions: {
      token: token,
      env: gcEnv
    }
  }
  );
};

/**
 * @async
 * @description Get's the current integration types from genesys cloud api.
 * @return {Promise<object>} { data, count, correlationIds, httpResults }
 */
export const checkUsageTrialForTenant = async () => {
  const urlbase = config.endpoints.endpoint;
  const orgId = getSessionStorageItem(AuthenticationConstants.ClientOrg);
  const url = `${urlbase}/getTrialUsageTenantDetails/${orgId}`;
  const token = gcAccessToken();
  const gcEnv = gcEnvironment();

  return await fetchWrap(
    {url,
    options: {
      method: "GET",
    },
    token,
    auth: true,
    cookies: false,
    headerOptions: {
      token: token,
      env: gcEnv
    }
  }
  );
};

// eslint-disable-next-line 
export default {
  fetchIntegrations,
  checkUsageTrialForTenant
};
